<!-- Στοιχεία Πελάτη
    Κωδικός Πελάτη
    Επωνυμία (Επώνυμο Όνομα ή Επωνυμία)
    Επαγγελμα
    Διεύθυνση (Οδός - Αριθμός - Τ.Κ - Πόλη - Χώρα)
    Α.Φ.Μ - Δ.Ο.Υ

Στοιχεία Χρέωσης
    Διεύθυνση χρέωσης: Πόντου 6, Χαιδάρι, Ελλάδα

Στοιχεία Αποστολής
    Διεύθυνση αποστολής: -

Στοιχεία Επικοινωνίας
    Υπεύθυνος επικοινωνίας: Κωνσταντίνος Αγγουρίδης
    Τηλέφωνο: 
    Email: 

 -->

<z-customer-select
    id="customer-selector"
    #ZCustomerSelect
    id="customer-selection"
    [label]="'Επιλογή Πελάτη'"
    [formControlName]="'CustomerId'"
    [searchable]="true"
    [mode]="'lockedit'"
    [fetchSubjects]="true"
    [selectedCustomer]="selectedCustomer()"
    [showClearIcon]="true"
    (ngModelChange)="modelChange.emit($event)"
    (rowDataSelect)="customerSelected.emit($event)"
></z-customer-select>
<!-- @if (selectedCustomer() != undefined) {
    <p-button
        title="Πατήστε εδώ για να μεταβάλετε τα στοιχεία του Πελάτη"
        [text]="true"
        class="flex"
        icon="pi pi-pencil"
        severity="success"
        size="small"
        (onClick)="editCustomer($event)"
    />
} @else {
    <p-button
        title="Πατήστε για να ανοίξετε μια Νέα Καρτέλα Πελάτη"
        [text]="true"
        class="flex"
        icon="pi pi-plus"
        severity="help"
        size="small"
        (onClick)="newCustomer()"
    />
} -->
<!-- <pre>
    {{ rootFormGroup.form?.value | json }}
</pre> -->
